import axios from "axios";
import { _DecryptService } from "../../service/EncryptDecryptService";

const isProduction = process.env.REACT_APP_IS_PRODUCTION === "true";
const API_BASE_URL = isProduction
  ? process.env.REACT_APP_API_ENDPOINT
  : process.env.REACT_APP_UAT_API_ENDPOINT;

const GetAlertStockSettingAPI = async () => {
  const endpoint = `${API_BASE_URL}/settings/alert-stock`;
  const headers = {
    Authorization: "Bearer " + _DecryptService(sessionStorage.getItem("token")),
    "Content-Type": "application/json",
  };
  const res = await axios.get(endpoint, { headers });
  return res.data;
};

const UpdateAlertStockSettingAPI = async (alertStockThreshold) => {
  const endpoint = `${API_BASE_URL}/settings/alert-stock`;
  const headers = {
    Authorization: "Bearer " + _DecryptService(sessionStorage.getItem("token")),
    "Content-Type": "application/json",
  };
  const payload = { AlertStockThreshold: alertStockThreshold };
  const res = await axios.put(endpoint, payload, { headers });
  return res.data;
};

export { GetAlertStockSettingAPI, UpdateAlertStockSettingAPI };
